// extracted by mini-css-extract-plugin
export default {"title":"pembeli-non-century_title__cW3B0","mb-40":"pembeli-non-century_mb-40__aoGUQ"};